import { render, staticRenderFns } from "./sendTransferBill.vue?vue&type=template&id=6d271552&"
import script from "./sendTransferBill.vue?vue&type=script&lang=js&"
export * from "./sendTransferBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports